// extracted by mini-css-extract-plugin
export var icons = "Tools-module--icons--+1HCD";
export var icon = "Tools-module--icon--bLnES";
export var preview = "Tools-module--preview--u+c7-";
export var logo = "Tools-module--logo--WGbRe";